<i18n src="./resources/locales.json"></i18n>

<template>
  <div class="total-stat">
    <div class="total-stat-count">
      <EcsCallbacksGraph v-if="slide.showAsGraph" :callbacks="callbacks" :class="alertType" />
      <span v-if="!slide.showAsGraph" :class="alertType">{{ kpiFormat(callbacks, 'number') }}</span>
    </div>
    <div v-if="!slide.showAsGraph" class="total-stat-description">
      <span v-for="(callback, i) in slide.callbacks" :key="callback">
        {{ callback }}<span v-if="i < slide.callbacks.length - 1">, </span>
      </span>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import EcsCallbacksGraph from './EcsCallbacksGraph.vue';
import EcsKpiFormatter from '@/mixins/ecs-kpi-formatter/EcsKpiFormatter';

export default {
  name: 'EcsCallbacksSlide',
  components: {
    EcsCallbacksGraph
  },

  mixins: [EcsKpiFormatter],

  props: {
    slide: {
      type: Object,
      default() {
        return {};
      }
    }
  },

  computed: {
    ...mapGetters('WALLBOARD', ['getStatisticsByBpids']),

    alertType() {
      const POSSIBLE_STATES_TYPES = [
        'callbacksProcessed',
        'callbacksFailedPercent',
        'callbacksPurged',
        'callbacksReachedPercent',
        'callbacksRequested',
        'callbacksToBeProcessed'
      ];
      let slideAlertType = 'None';

      if (this.selectedBusinessProcessesStats) {
        POSSIBLE_STATES_TYPES.every(stateType => {
          if (this.selectedBusinessProcessesStats[stateType].alertType === 'Alert') {
            slideAlertType = this.selectedBusinessProcessesStats[stateType].alertType;
            return false;
          } else if (this.selectedBusinessProcessesStats[stateType].alertType === 'Warning') {
            slideAlertType = this.selectedBusinessProcessesStats[stateType].alertType;
          }
          return true;
        });
      }
      return 'alert-type-' + slideAlertType.toLowerCase();
    },

    selectedBusinessProcessesStats() {
      return this.getStatisticsByBpids(this.slide.businessProcesses);
    },

    callbacks() {
      /* Prevent case sensitive issues */
      const callbackTypes = this.slide.callbacks.map(filter => filter.toLowerCase());

      if (!this.selectedBusinessProcessesStats) {
        return this.slide;
      }

      const countOfCallbacksInFilteredTypes = this.countByType(this.selectedBusinessProcessesStats, callbackTypes);

      if (this.slide.showAsGraph) {
        return countOfCallbacksInFilteredTypes;
      }

      return Object.keys(countOfCallbacksInFilteredTypes).reduce(
        (acc, type) => acc + countOfCallbacksInFilteredTypes[type],
        0
      );
    }
  },

  methods: {
    countByType(stats, types) {
      const initialData = {};
      const POSSIBLE_CALLBACKS_TYPES = {
        processed: stats.callbacksProcessed.value || 0,
        'failed percent': stats.callbacksFailedPercent.value || 0,
        purged: stats.callbacksPurged.value || 0,
        'reached percent': stats.callbacksReachedPercent.value || 0,
        requested: stats.callbacksRequested.value || 0,
        'to be proccesed': stats.callbacksToBeProcessed.value || 0
      };

      return types.reduce((acc, type) => {
        acc[type] = POSSIBLE_CALLBACKS_TYPES[type];

        return acc;
      }, initialData);
    }
  }
};
</script>

<style src="../scoped.css" scoped></style>
